<template>
    <div v-show="visible" class="sticky top-15 z-[1020] bg-warning px-5 py-2 text-sm font-medium text-black">
        <div id="sticky-banner-content" />
    </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { eventBus, events } from '@/eventBus.js';

const visible = ref(false);

const onShow = () => (visible.value = true);
const onHide = () => (visible.value = false);

onMounted(() => {
    eventBus.$on(events.showStickyBanner, onShow);
    eventBus.$on(events.hideStickyBanner, onHide);
});

onBeforeUnmount(() => {
    eventBus.$off(events.showStickyBanner, onShow);
    eventBus.$off(events.hideStickyBanner, onHide);
});
</script>
